import { useRef, useEffect, useCallback } from "react";
function useFocusTrap() {
  let active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const previousFocus = useRef(null);
  const element = useRef(null);
  const beforeBoundry = useRef(null);
  const afterBoundry = useRef(null);
  if (typeof document !== "undefined") {
    if (!beforeBoundry.current) {
      beforeBoundry.current = document.createElement("div");
      beforeBoundry.current.tabIndex = -1;
      beforeBoundry.current.setAttribute("aria-hidden", "true");
      beforeBoundry.current.addEventListener("focus", () => {
        if (element.current) {
          element.current.focus();
        }
      });
    }
    if (!afterBoundry.current) {
      afterBoundry.current = document.createElement("div");
      afterBoundry.current.tabIndex = -1;
      afterBoundry.current.setAttribute("aria-hidden", "true");
      afterBoundry.current.addEventListener("focus", () => {
        if (element.current) {
          element.current.focus();
        }
      });
    }
  }
  useEffect(() => {
    if (element.current) {
      if (active) {
        previousFocus.current = document.activeElement;
        element.current.focus();
      } else {
        if ((element.current.contains(document.activeElement) || document.activeElement === element.current) && previousFocus.current) {
          previousFocus.current.focus();
        }
      }
    }
    beforeBoundry.current.tabIndex = element.current && active ? 0 : -1;
    afterBoundry.current.tabIndex = element.current && active ? 0 : -1;
  }, [active]);
  const focusTrapRef = useCallback(el => {
    if (element.current) {
      element.current.parentNode.removeChild(beforeBoundry.current);
      element.current.parentNode.removeChild(afterBoundry.current);
    }
    element.current = el;
    if (element.current) {
      element.current.parentNode.insertBefore(beforeBoundry.current, element.current);
      if (element.current.nextSibling) {
        element.current.parentNode.insertBefore(afterBoundry.current, element.current.nextSibling);
      } else {
        element.current.parentNode.appendChild(afterBoundry.current);
      }
    }
  }, []);
  return [focusTrapRef];
}
export { useFocusTrap as default };